<template>
  <div>
    <b-card>
      <b-card-title>
        <h2>Documents</h2>
      </b-card-title>
      <documents
        :driver-data="driverData"
      />
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardTitle } from 'bootstrap-vue'
import Documents from '../../../documents/Documents.vue'

export default {
  components: {
    BCard, BCardTitle, Documents,
  },
  props: {
    driverData: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style>

</style>
